import {default as AUTH} from './app/auth/constants';
import {default as ORDER} from './app/order/constants';

export default {
  AUTH,
  ORDER
};



// WEBPACK FOOTER //
// ./src/constants.js